import React from "react";
import {KCard, KContainer, KUserProfile, noop, Translate, UserProfile as UserProfileType} from "@kopjra/uikit";
import {Col, Row} from "react-bootstrap";
import {useAuth0} from "@auth0/auth0-react";
import {
    useGetUserInfo,
    useResendEmailMutation,
    useResetPasswordMutation,
    useUpdateUserProfileMutation
} from "../api/user";

export const UserProfile: React.FC = () => {
    const {user, isAuthenticated} = useAuth0();

    const {data: extUser} = useGetUserInfo();

    const [resetPassword] = useResetPasswordMutation();
    const [resendEmail] = useResendEmailMutation();
    const [updateUserProfile] = useUpdateUserProfileMutation();


    if (extUser && !user) {
        return <KContainer>
            <Row>
                <Col md={6}>
                    <KCard header={<Translate i18nKey="bar.profile"/>}>
                        <KUserProfile
                            user={{
                                picture: extUser.picture || "https://kopjra-public.s3.eu-west-1.amazonaws.com/user-circle-solid.svg",
                                email_verified: true,
                                email: extUser.email,
                                name: `${extUser.firstname} ${extUser.lastname}`,
                                sub: "",
                            }}
                            onResetPassword={async () => noop()}
                            onResendEmail={async () => noop()}
                            onUpdateUserProfile={async () => noop()}
                        />
                    </KCard>
                </Col>
            </Row>
        </KContainer>
    } else {
        return isAuthenticated ? (
            <KContainer>
                <Row>
                    <Col md={6}>
                        <KCard header={<Translate i18nKey="bar.profile"/>}>
                            <KUserProfile
                                user={user as UserProfileType}
                                onResetPassword={async () => { await resetPassword().unwrap(); }}
                                onResendEmail={async () => { await resendEmail().unwrap(); }}
                                onUpdateUserProfile={async (up) => { await updateUserProfile(up).unwrap(); }}/>
                        </KCard>
                    </Col>
                </Row>
            </KContainer>
        ) : null;
    }
}
